<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="ch00_fm02"></a><a id="page_ii"></a><span class="small">WARFARE AND CULTURE SERIES</span></p>
<p class="center"><em>General Editor: Wayne E. Lee</em></p>
<p class="center1"><em>A Rabble in Arms:</em></p>
<p class="center"><em>Massachusetts Towns and Militiamen during King Philip’s War</em></p>
<p class="center">Kyle F. Zelner</p>
<p class="center1"><em>Empires and Indigenes: Intercultural Alliance, Imperial Expansion, and Warfare in the Early Modern World</em></p>
<p class="center">Edited by Wayne E. Lee</p>
<p class="center1"><em>Warfare and Culture in World History</em></p>
<p class="center">Edited by Wayne E. Lee</p>
<p class="center1"><em>Rustic Warriors: Warfare and the Provincial Solider on the New England Frontier, 1689–1748</em></p>
<p class="center">Steven C. Eames</p>
<p class="center1"><em>Forging Napoleon’s Grand Armée: Motivation, Military Culture, and Masculinity in the French Army, 1800-1808</em></p>
<p class="center">Michael J. Hughes</p>
<p class="center1"><em>Under the Shadow of Napoleon: French Influence on the American Way of Warfare from the War of 1812 to the Outbreak of WWII</em></p>
<p class="center">Michael A. Bonura</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?bc418eb8